import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

function AMLPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft size={20} className="mr-2" />
              Назад
            </Button>
          </Link>
          <h1 className="font-heading text-xl font-bold text-primary">AML ПОЛИТИКА</h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold text-foreground mb-8">Политика противодействия отмыванию денег (AML)</h2>
        
        <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
          <p className="text-lg">
            Skinkosh придерживается строгих стандартов в области противодействия отмыванию денег (AML) 
            и финансированию терроризма (CFT).
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">1. Общие положения</h3>
          <p>
            Настоящая Политика AML разработана в соответствии с международными стандартами 
            и рекомендациями FATF. Мы обязуемся предотвращать использование нашего сервиса 
            для незаконной деятельности.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">2. Меры по предотвращению отмывания денег</h3>
          <ul className="list-disc list-inside space-y-2">
            <li>Мониторинг транзакций на подозрительную активность</li>
            <li>Верификация крупных транзакций свыше определённых лимитов</li>
            <li>Блокировка адресов, связанных с незаконной деятельностью</li>
            <li>Сотрудничество с правоохранительными органами при необходимости</li>
            <li>Хранение записей о транзакциях в соответствии с требованиями законодательства</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">3. Запрещённая деятельность</h3>
          <p>Запрещается использование сервиса для:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Отмывания доходов, полученных преступным путём</li>
            <li>Финансирования терроризма</li>
            <li>Обхода международных санкций</li>
            <li>Мошенничества и других незаконных действий</li>
            <li>Операций с украденными криптовалютами</li>
          </ul>

          <h3 className="text-xl font-bold text-foreground mt-8">4. Верификация</h3>
          <p>
            Мы оставляем за собой право запросить дополнительную информацию и документы 
            для верификации личности при подозрительных транзакциях или при превышении 
            установленных лимитов.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">5. Отчётность</h3>
          <p>
            При обнаружении подозрительной активности мы обязаны сообщить об этом 
            соответствующим органам в соответствии с законодательством.
          </p>

          <h3 className="text-xl font-bold text-foreground mt-8">6. Лимиты транзакций</h3>
          <div className="bg-card border border-border rounded-lg p-4">
            <p><strong>Без верификации:</strong> до $1,000 в день</p>
            <p><strong>Базовая верификация:</strong> до $10,000 в день</p>
            <p><strong>Полная верификация:</strong> без ограничений</p>
          </div>

          <h3 className="text-xl font-bold text-foreground mt-8">7. Контакты</h3>
          <p>
            По вопросам AML политики обращайтесь: compliance@skinkosh.com
          </p>

          <p className="text-sm text-muted-foreground mt-8">
            Последнее обновление: Декабрь 2025
          </p>
        </div>
      </div>
    </div>
  );
}

export default AMLPage;
